const corporateType = {
  GROUP: "corporate-group",
  SUBSIDIARY: "corporate-subsidiary",
} as const;

type CorporateTypeKey = keyof typeof corporateType;

const getCorporateType = (val: string): string => {
  if (val in corporateType) {
    return corporateType[val as CorporateTypeKey];
  }
  return corporateType.GROUP;
};

export default getCorporateType;
